import { useState, useCallback, useEffect, useContext } from 'react';
import { MiawChatContext } from '../../contexts/MiawChatContext';
import { IApiHooksWithTriggerData } from '../../interfaces/app-interfaces';
import { sendTypingIndicator } from '../../utils/miaw/api-utils';
import { useNRLogging } from '../custom-hooks/useNRLogging';

type ITypingIndicatorType = 'TypingStartedIndicator' | 'TypingStoppedIndicator';

const useMIAWTypingIndicator = (): IApiHooksWithTriggerData<string, ITypingIndicatorType> => {
  const {
    state: { enableTypingIndicator },
  } = useContext(MiawChatContext);

  const { logCustomAttributesNR } = useNRLogging();
  const [data, setData] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error>();
  const [requestData, setRequestData] = useState<ITypingIndicatorType>();
  const {
    state: { conversationId },
  } = useContext(MiawChatContext);
  const trigger = useCallback((action: ITypingIndicatorType) => {
    setRequestData(action);
  }, []);

  useEffect(() => {
    if (requestData) {
      if (enableTypingIndicator !== true) {
        console.info('Typing indicator is disabled in the configuration.');
        setRequestData(undefined);
        return;
      }
      setLoading(true);
      if (conversationId) {
        logCustomAttributesNR('ca-chatbot-miaw-api-request', {
          logLevel: 'info',
          message: 'Starting new conversation',
          apiType: 'miawTypingIndicator',
          action: requestData,
        });
        sendTypingIndicator(conversationId, requestData)
          .then((res) => {
            setData(res);
            logCustomAttributesNR('ca-chatbot-miaw-api-response', {
              logLevel: 'info',
              message: 'Typing indicator sent successfully',
              apiType: 'miawTypingIndicator',
              action: requestData,
            });
          })
          .catch((err) => {
            setError(err);
            logCustomAttributesNR('ca-chatbot-miaw-api-error', {
              logLevel: 'error',
              message: 'Failed to send typing indicator',
              apiType: 'miawTypingIndicator',
              action: requestData,
              errorMessage: err.message,
            });
          })
          .finally(() => {
            setLoading(false);
            setRequestData(undefined);
          });
      }
    }
  }, [requestData]);

  return { data, loading, error, trigger };
};
export { useMIAWTypingIndicator };
